import React from "react";
import FadeLoader from "react-spinners/FadeLoader";
import PropTypes from "prop-types";
import { css } from "react-emotion";

const overlayStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingOverlay = ({ loading }) =>
  loading && (
    <div className={overlayStyle}>
      <FadeLoader color={"#D15050"} loading={loading} />
    </div>
  );

LoadingOverlay.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default LoadingOverlay;
